/**
 * Created by hanan on 16/11/28.
 */

require('./index.scss');
require('common/header/header.js');
require('common/css/footer.scss');
var Apply = require('../common/apply/apply');
$(function (){

  var divHeight=541;
  //查看详情按钮
  $('.main-content-left .case-right .detail').click(function(){
    var num=$(this).parents(".block").index();
    //alert(num);
    $(this).parents(".main-content").children(".main-content-right")
      .children(".product-case-right").removeAttr('id');
    $(this).parents(".main-content").children(".main-content-right")
    .children(".product-case-right:eq("+num+")").attr('id','show');

    divHeight=$('.main-content-right').height();
  });

  //立即申请按钮
  $(".main-content-left .case-right p").click(function () {
    $(this).parents(".main-content-left").find('.case-right img')
      .attr("src","/static/common/images/button-before.png");
    $(this).parents(".case-right").find('img')
      .attr("src","/static/common/images/button-after.png");
  });

  $(".main-content-left .case-right p").mouseenter(function () {
    $(this).parents(".main-content-left").find('.case-right img')
      .attr("src","/static/common/images/button-before.png");
    $(this).parents(".case-right").find('img')
      .attr("src","/static/common/images/button-after.png");
  });

  $(".main-content-left .case-right p").mouseleave(function () {
    $(this).parents(".main-content-left").find('.case-right img')
      .attr("src","/static/common/images/button-before.png");
  });

  $(window).scroll(function(){
    var left1=$('.main-content-right').offset().left;
    //var maxHeight=1470-divHeight-75;
    var maxHeight=2320-divHeight-75;//2320=170*11+450
  
    //滚轮滑动距离小于284时使用相对定位
    var minHeight=$('.main-banner').height()+$('.header').height();
    if($(window).scrollTop()<=minHeight){
      $('.main-content-right').css({'left':'0'});
      $('.main-content-right').css('position','relative');
    }

    //滚轮滑动距离大于284小于854时使用fixed定位
    if($(window).scrollTop()>minHeight && $(window).scrollTop()<=maxHeight){
      $(".main-content-right").css({'bottom':'','marginTop':'','left':left1,'top':'0px'});
      $('.main-content-right').css('position','fixed');
    }

    if($(window).scrollTop()>maxHeight){
      $(".main-content-right").css({'bottom':'41px','right':'0','left':'','top':'','margin':'0'});
      $('.main-content-right').css('position','absolute');
    }

  });

  // 百度统计埋点
  let detailButtonClicked = false;
  let detailProductNameClicked = '';
  let applyProductNameClicked = '';
  $('.main-content-left').on('click', 'a', function () {
    let text = $(this).text();
    let productName = $(this).closest('.case').find('.case-mid h3').text();
    let trackEventCategory;
    if (text == '查看详情') {
      trackEventCategory = 'detail-button';
      detailProductNameClicked = productName;
      detailButtonClicked = true;
    }
    else {
      if (detailButtonClicked) {
        _hmt.push(['_trackEvent', 'detail-apply-button', 'click', `product-${detailProductNameClicked}-${productName}`]);
      }
      trackEventCategory = 'apply-button';
      applyProductNameClicked = productName;
      detailButtonClicked = false;
    }
    _hmt.push(['_trackEvent', trackEventCategory, 'click', `product-${productName}`]);
  });

  // 提交弹层
  var applyDialog = Apply.create();
  applyDialog.on('apply', () => {
    _hmt.push(['_trackEvent', 'form', 'apply-success', `product-${applyProductNameClicked}`]);
  });
  $('.case-right p').click(function () {
    applyDialog.show();
  });

});


// WEBPACK FOOTER //
// ./static/product/index.js